import {
    backend_url,
    uninterceptedAxiosInstance,
    qs,
  } from "../common/commonVariables";

  export const createNewSet = async (
    name,
    parts,
    sets,
    organisation,
    createdByUser,
    partsOfSet,
    location,
    totalCost = 0,
    totalParts = 0
  ) => {
    try {
      let params = {
        name,
        parts,
        sets,
        createdByUser,
        organisation,
        partsOfSet,
        location,
        totalCost,
        totalParts
      };
  
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "sets",
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
     
      return the_response;
    } catch (err) {
     
      if (err.response) {
       
      } else if (err.request) {
       
      } else {
       
      }
     
      return {
        status: err.response.status,
        error: err.response?.data?.error,
      };
    }
  };

  export const updateSet = async (
    id,
    name,
    parts,
    sets,
    organisation,
    partsOfSet,
    location,
  ) => {
    try {
      let params = {
        name,
        parts,
        sets,
        organisation,
        partsOfSet,
        location,
      };
  
     
      const response = await uninterceptedAxiosInstance.put(
        backend_url + "sets/" + id,
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
     
      return the_response;
    } catch (err) {
     
      if (err.response) {
       
      } else if (err.request) {
       
      } else {
       
      }
     
      
      return {
        status: err.response.status,
        error: err.response?.data?.error,
      };
    }
  };

  export const getAllActiveSets = async (
    organisationID = "",
    locations,
    searchName = "",
    page = 1,
    pageSize = 9999
  ) => {
    let setFilter = {
      organisation: {
        id: {
          $eq: organisationID,
        },
      },
    };
  
  
    const queryParams = {};
    if (organisationID) {
      queryParams["organisation"] = Number(organisationID);
    }
  
    if (locations) {
      queryParams["location"] = Number(locations); // Add location query here
    }
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `sets/getset?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response.data.data;
  
     
      return the_response;
    } catch (err) {
     
      if (err.response) {
        return err.response.data;
       
      } else if (err.request) {
       
      } else {
       
      }
     
    }
  };

  export const deleteSet = async (ID,reason) => {
    try {
      let params = {
        data: [
          {
            id: ID,
            deleteReason: reason,
          },
        ],
      };
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "sets/removeSets",
        params,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
     
      return the_response;
    } catch (err) {
     
      if (err.response) {
       
      } else if (err.request) {
       
      } else {
       
      }
      return {
        status: err?.response?.status,
      };
     
    }
  };